import React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import search_icon from '../../../../assets/icons/search_icon.png';
import './style.css';
import {
  Card,
  Form,
  Input,
  Button,
  Row,
  Col,
  Steps,
  Upload,
  message,
  Select,
  Space,
  Table,
  Modal,
  Tooltip,
} from 'antd';

import delete_icon from '../../../../assets/icons/delete_icon.png';
import NoProject from '../../../../assets/images/NoProject.png';
import request_approval_img from '../../../../assets/icons/request_approval_img.png';
import DashboardCreateTable from '../dashboardCreateTable/index.js';
import {
  getBBSViewFiles,
  createBBSAlgorithm,
  getFinalBbsSummary,
} from '../../../bbsOptimization/redux/slice.js';
import * as XLSX from 'xlsx';
import {
  createViewProject,
  setProjectData,
  getManagerDashboard,
  createManagerApproveProject,
  createManagerApproveUser,
  createNewBBS,
  setnewBBSData,
  getViewProject,
  inactiveBbs,
  getBBsDetails,
  getInputFiles,
} from '../../redux/slice.js';
import { setApprovalView } from '../../../requestApproval/redux/slice.js';
import arrow_down from '../../../../assets/icons/arrow_down.png';
import pdf_image from '../../../../assets/icons/pdf_image.png';
import button_icon from '../../../../assets/icons/button_icon.png';
import excel_icon from '../../../../assets/icons/excel_icon.png';
import chevron_down from '../../../../assets/icons/chevron_down.png';
import download_pop_icon from '../../../../assets/icons/download_pop_icon.png';
import Photos_empty from '../../../../assets/images/Photos_empty.png';
import LocalStorage from '../../../../utilities/localStorage.js';
import { useSelector, useDispatch } from 'react-redux';
import { optimizeAlgorithmExport } from '../../../bbsOptimization/components/createBbs/OptimizeAlgorithmExport.js';
import VisualizationTable from '../../../bbsOptimization/components/createBbs/VisualizationTable.js';
import { apiUrl } from '../../../../utilities/apiClient.js';

const { Step } = Steps;

const DashboardCreate = () => {
  const user_details = LocalStorage.getItem('bbs_user');
  const { bbsViewFiles, bbsAlgorithmResult, bbsAlgorithmLoading } = useSelector(
    (state) => state.bbsOptimise,
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Option } = Select;

  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});
  const [searchQuery, setSearchQuery] = useState('');

  const [formattedData, setFormmatedData] = useState([]);
  const [selectedProjectName, setSelectedProjectName] = useState('');
  const [selectedLocationName, setSelectedLocationName] = useState('');
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [isSingleProjectCode, setIsSingleProjectCode] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isBackdropBlurred, setIsBackdropBlurred] = useState(false);
  const [results, setResults] = useState([]);
  const [optimizationDate, setOptimizationDate] = useState(null);

  const [inputFiles, setInputFiles] = useState([]);
  const [inputFilesViewCreate, setInputFilesViewCreate] = useState([]);
  const [data, setData] = useState(null);
  const [dataToSend, setDataToSend] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [showRemaining, setShowRemaining] = useState(false);
  const [consolidatedData, setConsolidatedData] = useState([]);
  const [pdfDownloadLoading, setPdfDownloadLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});

  const [activeButton, setActiveButton] = useState('new'); // Default active button
  const [isApprovalView, setIsApprovalView] = useState(false);
  const [rowVisibility, setRowVisibility] = React.useState({});
  const [selectedBbs, setSelectedBbs] = useState(null);
  const [downloading, setDownloading] = useState('');
  const [downloadingIndex, setDownloadingIndex] = useState(null);

  const handleApprovalClick = () => {
    dispatch(setApprovalView(true));
    navigate('/request-approval');
  };

  useEffect(() => {
    console.log(
      'bbsAlgorithmResultinmyviewpage just ot see:',
      bbsAlgorithmResult,
    );
  }, [bbsAlgorithmResult]);
  const {
    newBBSData,
    newBBSMessage,
    viewProject,
    newBBSpagination,
    getBbsData,
    inputFiless,
  } = useSelector((state) => state.projectList);

  useEffect(() => {
    dispatch(getBBsDetails());
  }, [dispatch]);

  console.log('getbbsdatainpage: ', getBbsData);

  const toggleRemaining = (key) => {
    setRowVisibility((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };
  const dataSource11 =
    newBBSData?.map((item) => {
      const { RequestApproval, User, request_approval_id } = item || {};
      const { givenName } = User || {};
      const {
        BBs,
        project_name,
        project_code,
        project_status,
        id,
        sbg,
        sbu,
        bu,
        user_remarks,
        wastagePer,
        quantity,
      } = RequestApproval || {};
      const { optimization_date } = BBs || {};

      return {
        key: project_code || Math.random(), // Unique key for each row
        project_name: project_name || 'N/A',
        project_code: project_code || 'N/A',
        sbg: sbg || 'N/A',
        sbu: sbu || 'N/A',
        bu: bu || 'N/A',
        id: id || 'N/A',
        wastagePer: wastagePer || 'N/A',
        wastagePer: wastagePer || 'N/A',
        project_status: project_status || 'N/A',
        quantity: quantity || 'N/A',
        BBs: BBs || [],
        givenName: givenName || 'N/A',
        optimization_date: optimization_date || 'N/A',
      };
    }) || [];

  const handleProjectClick = (projectCode) => {
    // Log the received projectCode for debugging
    console.log('Clicked Project Code:', projectCode);

    if (!projectCode) {
      message.error('Invalid project code');
      return;
    }

    form
      .validateFields()
      .then(() => {
        dispatch(getViewProject({ projectCode }))
          .then((response) => {
            console.log('response.id: ', response.payload);
            if (response?.payload) {
              //message.success('Project view successfully created!');

              //dispatch(setProjectData(response.payload));
              console.log('viewProject inside function: ', viewProject);

              // Navigate to the project page
              navigate(`/request-approval/${projectCode}`);
            } else {
              message.error(response?.payload?.message || 'Unknown error');
            }
          })
          .catch((error) => {
            console.error('API call failed:', error);
            message.error('Failed to submit the form.');
          });
      })
      .catch((info) => {
        console.log('Validation failed:', info);
      });
  };

  const handleCsvFileForAlgorithm = async () => {
    const formData = new FormData();
    formData.append('bbs_id', selectedBbs?.bbs);
    formData.append('project_code', selectedBbs?.projectCode);

    try {
      const response = await dispatch(createBBSAlgorithm(formData)).unwrap();
      if (response?.success && response?.results?.length > 0) {
        const { files } = response;
        console.log('files in dashboardCreate: ', files);
        setInputFilesViewCreate(Array.isArray(files) ? files : []);
        console.log('inputfilesin antherpage: ', inputFilesViewCreate);
        dispatch(getFinalBbsSummary({ bbs_id: selectedBbs?.bbs }));
        navigate('/bbs-optimization', {
          state: {
            step: 3,
            project_code: selectedBbs?.projectCode,
            bbs_id: selectedBbs?.bbs,
            files: Array.isArray(files) ? files : [],
          },
        });
      } else {
        console.error(
          'Algorithm failed:',
          response?.message || 'Unknown error',
        );
      }
    } catch (error) {
      console.error(
        'Error during submission:',
        error.message || 'Unknown error',
      );
    }
  };

  const Id = user_details?.user?.id;
  const [currpage, setCurrPage] = useState(1);
  useEffect(() => {
    if (newBBSData) {
      const payload = { userId: Id, page: currpage, search: searchQuery };
      dispatch(createNewBBS(payload)); // Fetch data if not already in Redux state
    } else {
      console.log('Fetched data: ', newBBSData);
    }
  }, [dispatch, Id, searchQuery]);

  console.log('datasourcesdfsdfdsf: ', newBBSData);
  console.log('pagination::sdfsdf: ', newBBSpagination);

  const clearform = () => {
    form.resetFields();
  };

  const handleBbsClick1 = (bbs, projectCode, isOptimised, isActive, date) => {
    console.log('BBS Clicked@@@@@@:', bbs); // Log the clicked BBS data
    console.log('BBS ProjectCode:', projectCode); // Log the clicked BBS data

    setSelectedBbs({ bbs, projectCode, isOptimised, isActive }); // Store the clicked BBS data
    console.log('selectedBbs immediately after setSelectedBbs:', selectedBbs);
    setIsModalVisible(true); // Show the modal

    const params = {
      bbsId: bbs,
      project_code: projectCode,
      type: 'raw-data',
    };

    dispatch(getBBSViewFiles(params))
      .then((res) => {
        console.log('BBS Algorithm Result:', res.payload);
        if (res.payload?.success) {
          const { results, input_files } = res.payload;

          setResults(results);
          setOptimizationDate(date);
          setInputFiles(Array.isArray(input_files) ? input_files : []);

          //optimizeAlgorithmExport(results);
        } else {
          console.error('Backend response does not indicate success.');
        }
      })
      .catch((error) => {
        console.error('Error fetching BBS view files:', error);
      });
  };
  // const handleBbsClick = (bbs, projectCode, type) => {
  //   console.log('BBS Clicked@@@@@@:', bbs); // Log the clicked BBS data
  //   console.log('BBS ProjectCode:', projectCode); // Log the clicked BBS data
  //   setSelectedBbs((prev) => ({
  //     ...prev,
  //     bbs,
  //     projectCode,
  //     isOptimised: prev?.isOptimised, // Preserve existing `isOptimised`
  //   })); // Store the clicked BBS data
  //   //console.log('selectedBbs immediately after setSelectedBbs:', selectedBbs);
  //   //setIsModalVisible(true); // Show the modal

  //   const params = {
  //     bbsId: bbs,
  //     project_code: projectCode,
  //     // bbsId: '2526BBS140',
  //     // project_code: 'Pro-001', // Assuming project_code is part of the `bbs` object
  //     type,
  //   };
  //   console.log('params: ', params);
  //   dispatch(getBBSViewFiles(params))
  //     .then((res) => {
  //       console.log('BBS Algorithm Result:', res.payload);
  //       if (res.payload?.success) {
  //         const { results } = res.payload; // Extract `results` array from response
  //         //setDataToSend({results,bbs_id}); // Store `results` in `dataToSend`
  //         //console.log('Results stored in dataToSend:', results);

  //         const { data } = res.payload;
  //         setConsolidatedData(data);

  //         if (type === 'consolidated-data') {
  //           const { formattedData } = res.payload;
  //           setFormmatedData(formattedData);
  //           console.log('formattedData:', formattedData);
  //           handleDownload(formattedData, bbs);
  //         }

  //         if (type === 'raw-data') {
  //           // Call the export function for raw data
  //           optimizeAlgorithmExport(results, bbs); // Pass results to export function
  //         }
  //       } else {
  //         console.error('Backend response does not indicate success.');
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching BBS view files:', error);
  //     });
  // };

  const handleBbsClick = async (bbs, projectCode, type) => {
    setDownloading(type); // Start loader

    const params = {
      bbsId: bbs,
      project_code: projectCode,
      type,
    };

    try {
      const res = await dispatch(getBBSViewFiles(params));

      if (res.payload?.success) {
        const { results, data, formattedData } = res.payload;

        setConsolidatedData(data);

        if (type === 'consolidated-data') {
          handleDownload(formattedData, bbs);
        }

        if (type === 'raw-data') {
          optimizeAlgorithmExport(results, bbs);
        }
      } else {
        console.error('Backend said it failed.');
      }
    } catch (err) {
      console.error('Error:', err);
    } finally {
      setDownloading(''); // Stop loader
    }
  };

  const handleDownload = (formattedData, bbs) => {
    if (!formattedData || formattedData.length === 0) {
      console.error('No data to download.');
      return;
    }

    console.log('Formatted Data Passed to Download:', formattedData);

    // Create a worksheet from the data
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Consolidated Data');

    // Trigger download of the workbook
    XLSX.writeFile(workbook, `${bbs}_Consolidated Data.xlsx`);
  };

  const handleUploadDownload = (file) => {
    // Use the file path directly

    const fileUrl = file.path;
    console.log('fileurl: ', fileUrl);

    // Check if the file URL exists
    if (fileUrl) {
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = file.originalname || 'downloaded-file.xlsx'; // Use original file name if available
      document.body.appendChild(link); // Append the link to the DOM
      link.click(); // Trigger the download
      document.body.removeChild(link); // Remove the link from the DOM
    } else {
      console.error('File URL not available for download');
    }
  };

  const downloadFinalBBSSummary = async (bbs) => {
    setDownloading('final'); // Start loader
    try {
      const response = await fetch(`${apiUrl}/bbs/output-file?bbs_id=${bbs}`, {
        method: 'GET',
        headers: {
          'Content-Type':
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `${bbs}_Final BBS Summary.xlsx`;
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading the file:', error);
    } finally {
      setDownloading(''); // Stop loader
    }
  };

  const downloadMappingSheet = async (bbs) => {
    try {
      const response = await fetch(`${apiUrl}/bbs/mapping-file?bbs_id=${bbs}`, {
        method: 'GET',
        headers: {
          'Content-Type':
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Optional
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element
      const a = document.createElement('a');
      a.href = url;
      a.download = `${bbs}_Mapping sheet.xlsx`; // Adjust the file name as needed
      document.body.appendChild(a);
      a.click();

      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  };

  const downloadInputFiles = async (blobName, fullFilename,index) => {
      setDownloadingIndex(index);
      try {
        const token = localStorage.getItem('token');
        console.log('token received: ', token);
  
        const response = await fetch(
          `${apiUrl}/bbs/input-files?blobName=${blobName}`,
          {
            method: 'GET',
            headers: {
              'Content-Type':
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Optional
              // Authorization: `Bearer ${token}`, // Add Authorization token
            },
          },
        );
  
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
  
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
  
        // Create a temporary anchor element
        const a = document.createElement('a');
        a.href = url;
        a.download = `${fullFilename}`; // Adjust the file name as needed
        document.body.appendChild(a);
        a.click();
  
        // Cleanup
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } catch (error) {
        console.error('Error downloading the file:', error);
      } finally {
        setDownloadingIndex(null);
      }
    };
  

 
  const handleDelete = (bbs_id) => {
    const params = { bbs_id: bbs_id };

    // Call the first API: inactiveBbs
    dispatch(inactiveBbs(params))
      .then((res) => {
        if (res.payload?.success) {
          // After successful deletion, navigate and set the bbs_id in the location state
          navigate('/bbs-optimization', { state: { step: 0, bbs_id: bbs_id } });
        } else {
          console.error(
            'Backend response does not indicate success for inactiveBbs.',
          );
        }
      })
      .catch((error) => {
        console.error('Error handling delete:', error);
      });
  };
  // const handle_PdfDownload_cuttingPattern = async (bbsId,projectCode) => {
  //     setPdfDownloadLoading(true);
  //     const Url = process.env.REACT_APP_API_URL;
  //     const apiUrl = `${Url}/pdf/download`;

  //     const payload = {
  //       bbs_id:bbsId,
  //       project_code: projectCode,
  //     };

  //     console.log('hree inside the pdfdownload: ',payload)
  //     try {
  //       const response = await fetch(apiUrl, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify(payload),
  //       });

  //       if (!response.ok) {
  //         throw new Error('Failed to download PDF');
  //       }

  //       const blob = await response.blob();
  //       const url = window.URL.createObjectURL(blob);

  //       // Create a temporary link element for downloading
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.download = 'downloaded_file.pdf'; // Set the default file name
  //       document.body.appendChild(link);
  //       link.click();

  //       // Clean up
  //       link.remove();
  //       window.URL.revokeObjectURL(url);
  //       setPdfDownloadLoading(false);
  //       message.success('PDF downloaded successfully.');
  //     } catch (error) {
  //       setPdfDownloadLoading(false);
  //       message.error('Failed to download PDF');
  //       console.error('Error downloading PDF:', error);
  //     }
  //   };
  const handle_PdfDownload_cuttingPattern = async (bbsId, projectCode) => {
    setPdfDownloadLoading(true);
    const Url = process.env.REACT_APP_API_URL;

    // Create URL with parameters
    const params = new URLSearchParams({
      bbs_id: bbsId,
      project_code: projectCode,
    });
    const apiUrl = `${Url}/pdf/download?${params}`;
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to download PDF');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link element for downloading
      const link = document.createElement('a');
      link.href = url;
      link.download = `${bbsId}_Cutting Pattern.pdf`;
      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(url);
      setPdfDownloadLoading(false);
      message.success('Cutting pattern downloaded successfully');
    } catch (error) {
      setPdfDownloadLoading(false);
      message.error('Failed to download PDF');
      console.error('Error downloading PDF:', error);
    }
  };

  const VisualizationBar = ({ data }) => {
    const total = data.reduce((sum, item) => sum + item.value, 0); // Calculate the total value

    return (
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '36px',
          borderRadius: '20px',
          overflow: 'hidden',
        }}
      >
        {data.map((item, index) => (
          <div
            key={index}
            style={{
              backgroundColor: item.color, // Assign color for each segment
              width: `${(item.value / total) * 100}%`, // Calculate width as percentage
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#fff',
              fontSize: '12px',
              fontWeight: 'bold',
            }}
          >
            {item.value}
          </div>
        ))}
      </div>
    );
  };

  const dataSource1 = [
    {
      key: '1',
      size: 50,
      repitition: 20,
      visualizationData: [
        { label: 'A', value: 40, color: '#FFB0B0' },
        { label: 'B', value: 30, color: '#FFD09B' },
        { label: 'C', value: 30, color: '#FFECC8' },
      ],
    },
    {
      key: '1',
      size: 50,
      repitition: 20,
      visualizationData: [
        { label: 'A', value: 10, color: '#FFB0B0' },
        { label: 'B', value: 30, color: '#FFD09B' },
        { label: 'C', value: 30, color: '#FFECC8' },
      ],
    },
    {
      key: '1',
      size: 50,
      repitition: 20,
      visualizationData: [
        { label: 'A', value: 40, color: '#FFB0B0' },
        { label: 'B', value: 30, color: '#FFD09B' },
        { label: 'C', value: 30, color: '#FFECC8' },
      ],
    },
    {
      key: '2',
      size: 25,
      repitition: 32,
      visualizationData: [
        { label: 'A', value: 30, color: '#FFB0B0' },
        { label: 'B', value: 50, color: '#FFD09B' },
        { label: 'C', value: 10, color: '#FFECC8' },
        { label: 'D', value: 10, color: '#FFF7D1' },
      ],
    },
  ];

  const columns1 = [
    {
      title: 'Size (In MM)',
      dataIndex: 'size',
      key: 'size',
      width: '60px',
      ellipsis: true,
    },
    {
      title: 'Repitition',
      dataIndex: 'repitition',
      key: 'repitition',
      width: '60px',
      ellipsis: true,
    },
    {
      title: 'Cutting Pattern',
      key: 'visualization',
      width: '250px',
      ellipsis: true,
      render: (_, record) => (
        <VisualizationBar data={record.visualizationData} />
      ),
    },
  ];
  const dataSource = [
    {
      key: '1',
      projectCode: 'PA123',
      existingBBS: ['BBS001', 'BBS002', 'BBS003'],
    },
    {
      key: '2',
      projectCode: 'PB456',
      existingBBS: ['BBS004', 'BBS005'],
    },
    {
      key: '3',
      projectCode: 'PC789',
      existingBBS: ['BBS006'],
    },
  ];

  const columns = [
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Project Code
        </span>
      ),
      dataIndex: 'project_code', // The array in bbsList
      key: 'project_code',
      width: '150px',
      ellipsis: true,
      render: (text, record) => {
        console.log('record quantity : ', record);

        return (
          <span
            style={{
              marginLeft: '7px',
              color: '#0092DD',
              fontFamily: "'SF Pro Text', sans-serif",
              fontWeight: '500',
              fontSize: '12px',
            }}
          >
            <a
              onClick={() =>
                handleProjectClick(record.RequestApproval.project_code)
              } // Pass the text (project_code) here
              style={{ textDecoration: 'underline', color: '#0092DD' }} // Underline and color
            >
              {record.RequestApproval.project_code}
            </a>
          </span>
          // <div className="text-[#667085] text-[12px] font-['SF-Pro-Text-Regular, sans-serif'] ml-[8px]">
          //   {record.project_name}/{text}{' '}
          //   {/* Combine project_code and project_name */}
          // </div>
        );
      },
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Project Name
        </span>
      ),
      dataIndex: 'project_name', // The array in bbsList
      key: 'project_name',
      width: '150px',
      ellipsis: true,
      render: (text, record) => {
        return (
          <span
            style={{
              marginLeft: '7px',
              color: '#667085',
              fontFamily: "'SF Pro Text', sans-serif",
              fontWeight: '500',
              fontSize: '12px',
            }}
          >
            {record.RequestApproval.project_name}
          </span>
          // <div className="text-[#667085] text-[12px] font-['SF-Pro-Text-Regular, sans-serif'] ml-[8px]">
          //   {record.project_name}/{text}{' '}
          //   {/* Combine project_code and project_name */}
          // </div>
        );
      },
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Existing BBS
        </span>
      ),
      dataIndex: 'BBs',
      key: 'BBs',
      width: '168px',
      ellipsis: true,
      render: (BBs, record) => {
        const projectCode = record?.RequestApproval?.project_code;
        const bbsArray = record?.RequestApproval?.BBs || [];
        const displayBbs = bbsArray.slice(0, 4); // Get the first 4 bbs_id
        const remainingBbsArray = bbsArray.slice(4); // Remaining BBS
        const remainingCount = remainingBbsArray.length; // Count the remaining bbs_id

        const isRowVisible = rowVisibility[projectCode] || false; // Check if the row is expanded

        return (
          <span
            style={{
              marginLeft: '7px',
              color: '#0092DD',
              fontFamily: "'SF Pro Text', sans-serif",
              fontWeight: '500',
              fontSize: '12px',
              display: 'flex',
              flexWrap: 'wrap',
              flexDirection: 'column',
              gap: '5px',
            }}
          >
            {displayBbs.map((bbs, index) => (
              <div key={index} style={{ display: 'flex', gap: '5px' }}>
                {bbs?.is_active === true ? (
                  <a
                    // key={index}
                    style={{
                      textDecoration: 'underline',
                      color: '#0092DD',
                      display: 'block',
                    }}
                    onClick={() =>
                      handleBbsClick1(
                        bbs.bbs_id,
                        record.RequestApproval.project_code,
                        bbs.is_optimised,
                        bbs.is_active,
                        bbs.optimization_date,
                      )
                    }
                  >
                    {bbs?.bbs_id || 'N/A'}
                  </a>
                ) : (
                  <span
                    style={{
                      textDecoration: 'underline',
                      color: 'red',
                      display: 'block',
                      cursor: 'pointer',
                    }}
                    onClick={() =>
                      handleBbsClick1(
                        bbs.bbs_id,
                        record.RequestApproval.project_code,
                        bbs.is_optimised,
                        bbs.is_active,
                        bbs.optimization_date,
                      )
                    }
                  >
                    {bbs?.bbs_id || 'N/A'}
                  </span>
                )}
                {bbs?.is_optimised === false ? (
                  <Tooltip
                    title={
                      bbs?.is_active === false
                        ? "ID can't be used, optimize new BBS"
                        : ''
                    }
                    placement="top"
                    mouseEnterDelay={0.3} // Optional: Delay before showing tooltip
                  >
                    <span
                      style={{
                        backgroundColor:
                          bbs?.is_active === false ? '#FFE4E4' : '#FFF4E0', // Light red for Deactivated, Light yellow for Pending
                        padding: '4px 5px',
                        marginTop: '2px',
                        color: bbs?.is_active === false ? '#D40000' : '#FFB800', // Dark red for Deactivated, Dark yellow for Pending
                        fontSize: '7px',
                        fontWeight: 'bold',
                        marginLeft: '2px',
                        width: bbs?.is_active === false ? '48px' : '38px', // 48px for Deactivated, 38px for Pending
                        textAlign: 'center',
                        borderRadius: '3px', // Optional: Add rounded corners
                      }}
                    >
                      {bbs?.is_active === false ? 'Deactivated' : 'Pending'}
                    </span>
                  </Tooltip>
                ) : null}
              </div>
            ))}
            {remainingCount > 0 && (
              <a
                onClick={() => toggleRemaining(projectCode)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#667085',
                  fontSize: '12px',
                  width: '30px',
                  cursor: 'pointer',
                  marginLeft: '128px',
                  marginTop: '-21px',
                }}
              >
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30px',
                    borderRadius: '50%',
                    backgroundColor: '#FFFFFF',
                    color: '#0092DD',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    marginRight: '4px',
                    border: '1px solid #EAECF0',
                  }}
                >
                  +{remainingCount}
                </span>
              </a>
            )}
            {isRowVisible &&
              remainingBbsArray.map((bbs, index) => (
                <div
                  key={`remaining-${projectCode}-${index}`}
                  style={{ display: 'flex', gap: '5px' }}
                >
                  {bbs?.is_active === true ? (
                    <a
                      style={{
                        textDecoration: 'underline',
                        color: '#0092DD',
                        display: 'block',
                      }}
                      onClick={() =>
                        handleBbsClick1(
                          bbs.bbs_id,
                          record.RequestApproval.project_code,
                          bbs.is_optimised,
                          bbs.is_active,
                          bbs.optimization_date,
                        )
                      }
                    >
                      {bbs?.bbs_id || 'N/A'}
                    </a>
                  ) : (
                    <span
                      style={{
                        textDecoration: 'underline',
                        color: 'red',
                        display: 'block',
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        handleBbsClick1(
                          bbs.bbs_id,
                          record.RequestApproval.project_code,
                          bbs.is_optimised,
                          bbs.is_active,
                          bbs.optimization_date,
                        )
                      }
                    >
                      {bbs?.bbs_id || 'N/A'}
                    </span>
                  )}

                  {/* Add the status label (Pending or Deactivated) */}
                  {bbs?.is_optimised === false ? (
                    <Tooltip
                      title={
                        bbs?.is_active === false
                          ? "ID can't be used, optimize new BBS"
                          : ''
                      }
                      placement="top"
                      mouseEnterDelay={0.3}
                    >
                      <span
                        style={{
                          backgroundColor:
                            bbs?.is_active === false ? '#FFE4E4' : '#FFF4E0', // Light red for Deactivated, Light yellow for Pending
                          padding: '4px 5px',
                          marginTop: '2px',
                          color:
                            bbs?.is_active === false ? '#D40000' : '#FFB800', // Dark red for Deactivated, Dark yellow for Pending
                          fontSize: '7px',
                          fontWeight: 'bold',
                          marginLeft: '2px',
                          width: bbs?.is_active === false ? '48px' : '38px', // 48px for Deactivated, 38px for Pending
                          textAlign: 'center',
                          borderRadius: '3px',
                        }}
                      >
                        {bbs?.is_active === false ? 'Deactivated' : 'Pending'}
                      </span>
                    </Tooltip>
                  ) : null}
                </div>
              ))}
          </span>
        );
      },
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Quantity Optimized (in MT)
        </span>
      ),
      dataIndex: 'RequestApproval',
      key: 'quantity',
      width: '165px',
      ellipsis: true,
      render: (RequestApproval, record) => {
        const projectCode = record?.RequestApproval?.project_code;
        const BBs = RequestApproval?.BBs || []; // Extract BBs array

        // Calculate the total quantity from the Summaries array
        const totalQuantities = BBs.map((bbs) =>
          (bbs?.Summaries || []).reduce(
            (sum, summary) => sum + (summary.quantity || 0),
            0,
          ),
        );

        const displayTonnage = totalQuantities.slice(0, 4); // Show first 4 summed values
        const remainingTonnage = totalQuantities.slice(4); // Remaining summed values
        const remainingCount = remainingTonnage.length; // Count the remaining tonnage

        const isRowVisible = rowVisibility[projectCode] || false;

        return (
          <span
            style={{
              marginLeft: '7px',
              color: '#667085',
              fontFamily: "'SF Pro Text', sans-serif",
              fontWeight: '500',
              fontSize: '12px',
              display: 'flex',
              flexDirection: 'column',
              gap: '5px',
            }}
          >
            {/* Display first 4 Summed Quantities */}
            {displayTonnage.map((sum, index) => (
              <span key={index} style={{ marginLeft: '8px' }}>
                {sum.toFixed(2) || 'N/A'}{' '}
                {/* Display sum with 2 decimal places */}
              </span>
            ))}

            {/* Show remaining count */}
            {remainingCount > 0 && (
              <span
                onClick={() => toggleRemaining(projectCode)}
                style={{
                  display: 'flex',
                  alignItems: 'end',
                  justifyContent: 'center',
                  color: '#667085',
                  fontSize: '12px',
                  cursor: 'pointer',
                  marginTop: '-21px',
                  marginLeft: '60px',
                }}
              >
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30px',
                    height: '17px',
                    borderRadius: '50%',
                    backgroundColor: '#FFFFFF',
                    color: '#0092DD',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    border: '1px solid #EAECF0',
                    marginRight: '4px',
                  }}
                >
                  +{remainingCount}
                </span>
              </span>
            )}

            {/* Render remaining summed quantities if expanded */}
            {isRowVisible &&
              remainingTonnage.map((sum, index) => (
                <span
                  key={`remaining-${projectCode}-${index}`}
                  style={{ marginLeft: '8px' }}
                >
                  {sum.toFixed(2) || 'N/A'}
                </span>
              ))}
          </span>
        );
      },
    },

    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Wastage (%)
        </span>
      ),
      dataIndex: 'RequestApproval',
      key: 'wastagePer',
      ellipsis: true,
      render: (RequestApproval, record) => {
        const projectCode = record?.RequestApproval?.project_code;
        const BBs = RequestApproval?.BBs || []; // Ensure BBs is defined

        // Calculate wastage for each BBS ID
        const calculatedWastage = BBs.map((bbs) => {
          const summaries = bbs?.Summaries || []; // Get summaries array

          // Calculate total wastage for this BBS ID
          const totalWastage = summaries.reduce(
            (acc, item) => acc + item.proportion * item.offcut,
            0,
          );

          return {
            ...bbs,
            wastagePer: totalWastage.toFixed(2), // Format to 2 decimal places
          };
        });

        const displayWastage = calculatedWastage.slice(0, 4); // Show first 4 wastage values
        const remainingWastage = calculatedWastage.slice(4); // Remaining wastage values
        const remainingCount = remainingWastage.length; // Count the remaining wastage

        const isRowVisible = rowVisibility[projectCode] || false;

        return (
          <div
            style={{
              color: '#667085',
              fontFamily: "'SF Pro Text', sans-serif",
              fontWeight: '500',
              fontSize: '12px',
              display: 'flex',
              flexDirection: 'column',
              gap: '5px',
            }}
          >
            {/* Display first 4 Wastage values */}
            {displayWastage.map((bbs, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                  gap: '3px',
                  marginLeft: '7px',
                }}
              >
                <span style={{ color: '#667085' }}>{bbs.wastagePer}%</span>
              </div>
            ))}

            {/* Show remaining count beside the last wastage */}
            {remainingCount > 0 && (
              <span
                onClick={() => toggleRemaining(projectCode)}
                style={{
                  display: 'flex',
                  alignItems: 'end',
                  justifyContent: 'center',
                  color: '#667085',
                  fontSize: '12px',
                  cursor: 'pointer',
                  marginTop: '-21px',
                  marginLeft: '60px',
                }}
              >
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30px',
                    height: '17px',
                    borderRadius: '50%',
                    backgroundColor: '#FFFFFF',
                    color: '#0092DD',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    border: '1px solid #EAECF0',
                    marginLeft: '4px',
                  }}
                >
                  +{remainingCount}
                </span>
              </span>
            )}

            {/* Render remaining wastage values if expanded */}
            {isRowVisible &&
              remainingWastage.map((bbs, index) => (
                <div
                  key={`remaining-${projectCode}-${index}`}
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    gap: '3px',
                    marginLeft: '7px',
                  }}
                >
                  <span style={{ color: '#667085' }}>{bbs.wastagePer}%</span>
                </div>
              ))}
          </div>
        );
      },
    },

    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Optimized By
        </span>
      ),
      dataIndex: 'RequestApproval',
      key: 'givenName',
      // width: '130px',
      ellipsis: true,
      render: (RequestApproval, record) => {
        const projectCode = record?.RequestApproval?.project_code;
        const BBs = RequestApproval?.BBs || []; // Ensure BBs is defined
        const displayOptimizedBy = BBs.slice(0, 4); // Show first 4 entries
        const remainingOptimizedBy = BBs.slice(4); // Remaining optimized by entries
        const remainingCount = remainingOptimizedBy.length; // Count the remaining entries

        const isRowVisible = rowVisibility[projectCode] || false;

        return (
          <div
            style={{
              color: '#667085',
              fontFamily: "'SF Pro Text', sans-serif",
              fontWeight: '500',
              fontSize: '12px',
              display: 'flex',
              flexDirection: 'column',
              gap: '5px',
            }}
          >
            {/* Display first 4 Optimized By values */}
            {displayOptimizedBy.map((bbs, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                  gap: '3px',
                  marginLeft: '8px',
                }}
              >
                <span style={{ color: '#667085' }}>
                  {bbs?.User?.givenName || 'N/A'}
                </span>
              </div>
            ))}

            {/* Show remaining count beside the last Optimized By */}
            {remainingCount > 0 && (
              <span
                onClick={() => toggleRemaining(projectCode)}
                style={{
                  display: 'flex',
                  alignItems: 'end',
                  justifyContent: 'center',
                  color: '#667085',
                  fontSize: '12px',
                  cursor: 'pointer',
                  marginLeft: '60px',
                  marginTop: '-21px',
                }}
              >
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30px',
                    height: '17px',
                    borderRadius: '50%',
                    backgroundColor: '#FFFFFF',
                    color: '#0092DD',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    border: '1px solid #EAECF0',
                    marginLeft: '4px',
                  }}
                >
                  +{remainingCount}
                </span>
              </span>
            )}

            {/* Render remaining Optimized By values if expanded */}
            {isRowVisible &&
              remainingOptimizedBy.map((bbs, index) => (
                <div
                  key={`remaining-${projectCode}-${index}`}
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    gap: '3px',
                    marginLeft: '8px',
                  }}
                >
                  <span style={{ color: '#667085' }}>
                    {bbs?.User?.givenName || 'N/A'}
                  </span>
                </div>
              ))}
          </div>
        );
      },
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Date
        </span>
      ),
      dataIndex: 'RequestApproval',
      key: 'optimizationDates',
      // width: '140px',
      ellipsis: true,
      render: (RequestApproval, record) => {
        const projectCode = record?.RequestApproval?.project_code;
        const BBs = RequestApproval?.BBs || []; // Ensure BBs is defined
        const displayOptimizationDate = BBs.slice(0, 4); // Show first 4 entries
        const remainingOptimizationDate = BBs.slice(4); // Remaining optimization date entries
        const remainingCount = remainingOptimizationDate.length; // Count the remaining entries

        const isRowVisible = rowVisibility[projectCode] || false;

        return (
          <div
            style={{
              color: '#667085',
              fontFamily: "'SF Pro Text', sans-serif",
              fontWeight: '500',
              fontSize: '12px',
              display: 'flex',
              flexDirection: 'column',
              gap: '5px',
            }}
          >
            {/* Display first 4 Optimization Dates */}
            {displayOptimizationDate.map((bbs, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                  gap: '10px',
                  marginLeft: '8px',
                }}
              >
                <span style={{ color: '#667085' }}>
                  {bbs?.optimization_date
                    ? new Date(bbs.optimization_date).toLocaleDateString()
                    : 'N/A'}
                </span>
              </div>
            ))}

            {/* Show remaining count beside the last Optimization Date */}
            {remainingCount > 0 && (
              <span
                onClick={() => toggleRemaining(projectCode)}
                style={{
                  display: 'flex',
                  alignItems: 'end',
                  justifyContent: 'center',
                  color: '#667085',
                  fontSize: '12px',
                  cursor: 'pointer',
                  marginLeft: '60px',
                  marginTop: '-21px',
                }}
              >
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30px',
                    height: '17px',
                    borderRadius: '50%',
                    backgroundColor: '#FFFFFF',
                    color: '#0092DD',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    border: '1px solid #EAECF0',
                    marginLeft: '4px',
                  }}
                >
                  +{remainingCount}
                </span>
              </span>
            )}

            {/* Render remaining Optimization Dates if expanded */}
            {isRowVisible &&
              remainingOptimizationDate.map((bbs, index) => (
                <div
                  key={`remaining-${projectCode}-${index}`}
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    gap: '10px',
                    marginLeft: '8px',
                  }}
                >
                  <span style={{ color: '#667085' }}>
                    {bbs?.optimization_date
                      ? new Date(bbs.optimization_date).toLocaleDateString()
                      : 'N/A'}
                  </span>
                </div>
              ))}
          </div>
        );
      },
    },

    {
      title: '', // No header for this column
      key: 'action',
      render: (record) => (
        <Button
          onClick={() =>
            navigate('/bbs-optimization', {
              state: {
                requestApprovalId: record.key,
                data: record, // Pass the full record or relevant data
              },
            })
          }
          type="primary"
          style={{
            backgroundColor: '#1C4E9D',
            borderRadius: '8px',
            text: '#FFFFFF',
            fontSize: '12px',
            padding: '8px 16px',
          }}
        >
          Optimize new BBS
        </Button>
      ),
    },
  ];

  const dummyColumn = [
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Project Code
          {/* <img
            src={arrow_down}
            alt="icon"
            style={{ marginLeft: '5px', width: '16px', height: '16px' }}
          /> */}
        </span>
      ),
      dataIndex: 'project_code', // The array in bbsList
      key: 'project_code',
      // width: '160px',
      ellipsis: true,
      render: (text) => (
        <span
          style={{
            marginLeft: '7px',
            color: '#0092DD',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          <a
            //onClick={() => handleProjectClick(text)} // Pass the text (project_code) here
            style={{ textDecoration: 'underline', color: '#0092DD' }} // Underline and color
          >
            {text || 'N/A'}
          </a>
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Project Name
          {/* <img
            src={arrow_down}
            alt="icon"
            style={{ marginLeft: '5px', width: '16px', height: '16px' }}
          /> */}
        </span>
      ),
      dataIndex: 'project_name',
      key: 'project_name',
      // width: '160px',
      ellipsis: true,
      render: (text) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          {text || 'N/A'}
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          Request Id
        </span>
      ),
      dataIndex: 'id',
      key: 'id',
      width: '160px',
      ellipsis: true,
      render: (text) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          {text}
        </span>
      ),
      //sorter: (a, b) => a?.required_weight?.localeCompare(b?.required_weight),
      //responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          BBS
          {/* <img
            src={arrow_down}
            alt="icon"
            style={{ marginLeft: '5px', width: '16px', height: '16px' }}
          /> */}
        </span>
      ),
      dataIndex: 'BBs',
      key: 'BBS',
      width: '160px',
      ellipsis: true,
      render: (BBs) => (
        <span
          style={{
            marginLeft: '7px',
            color: '#0092DD',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            gap: '5px',
          }}
        >
          {BBs && BBs.length > 0 ? (
            <>
              <a
                style={{
                  textDecoration: 'underline',
                  color: '#0092DD',
                  display: 'block',
                }}
                // Add your click handler here
              >
                {BBs[0].bbs_id || 'N/A'}
              </a>
              {BBs.length > 1 && (
                <span
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '5px',
                    color: '#667085',
                    fontSize: '12px',
                  }}
                >
                  <span style={{ marginRight: '4px' }}>+{BBs.length - 1}</span>
                  <img
                    src="remaining_icon_url" // Replace with your icon URL
                    alt="remaining count"
                    style={{ width: '12px', height: '12px' }}
                  />
                </span>
              )}
            </>
          ) : (
            'N/A'
          )}
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          SBG
        </span>
      ),
      dataIndex: 'sbg',
      key: 'sbg',
      width: '160px',
      ellipsis: true,
      render: (text) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          SBU
        </span>
      ),
      dataIndex: 'sbu',
      key: 'sbu',
      width: '160px',
      ellipsis: true,
      render: (text) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          {text}
        </span>
      ),
    },
  ];

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsBackdropBlurred(false);
    setSelectedBbs(null);
  };

  const handleConfirm = () => {
    setIsModalVisible(false);
    setIsBackdropBlurred(false);
    // Add your download logic here
    console.log('Download Confirmed');
  };

  const handleButtonClick = (buttonType) => {
    setActiveButton(buttonType); // Update the active button
  };

  console.log('reqidincrebbs: ', newBBSData?.data?.request_approval_id);
  const [currentStep, setCurrentStep] = useState(0);
  const [search, setSearch] = useState();

  const [isProjectExisting, setIsProjectExisting] = useState(false); // To track if the project exists or not

  const steps = [
    {
      title: <div className="step-title">Approval Request</div>,
      content: (
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            project_code: '', // Initial empty project code
            project_name: '', // Initial empty values
            bu: '',
            sbu: '',
            sbg: '',
            quantity: '',
            wastagePer: '',
            role: '',
            remarks: '',
          }}
        >
          <Row gutter={24}>
            <Col span={12} sm={12} xs={24}>
              <Row gutter={12} align="middle">
                {/* Input field for Project Code */}
                <Col span={10} xs={20} sm={18} lg={21}>
                  <Form.Item label="Project Code" name="project_code">
                    <Input placeholder="Enter Project code" />
                  </Form.Item>
                </Col>
                {/* Fetch link */}
                <Col span={2} xs={4} sm={3} lg={3}>
                  <a className="fetch-link">Fetch</a>
                </Col>
              </Row>
            </Col>

            {/* Dynamically disabled fields */}
            <Col span={12} xs={24} sm={12}>
              <Form.Item label="Project Name" name="project_name">
                <Input placeholder="Enter Project Name" disabled={isDisabled} />
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item label="BU" name="bu">
                <Input placeholder="Enter BU" disabled={isDisabled} />
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item label="SBU" name="sbu">
                <Input placeholder="Enter SBU" disabled={isDisabled} />
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item label="SBG" name="sbg">
                <Input placeholder="Enter SBG" disabled={isDisabled} />
              </Form.Item>
            </Col>

            {/* Dynamically enabled/disabled fields based on project status */}
            <Col span={12} xs={24} sm={12}>
              <Form.Item label="Total Quantity of Project" name="quantity">
                <Input
                  placeholder="Enter total quantity of project"
                  disabled={isDisabled && isSuccess}
                />
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Wastage Percentage Considered"
                name="wastagePer"
              >
                <Input
                  placeholder="Enter wastage percentage considered"
                  disabled={isDisabled && isSuccess}
                />
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item label="Role Of The BBS User" name="role">
                <Select
                  placeholder="Select role of the bbs user"
                  disabled={isDisabled && isSuccess}
                >
                  <Option value="admin">Admin</Option>
                  <Option value="editor">Editor</Option>
                  <Option value="viewer">Viewer</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24} xs={24} sm={24}>
              <Form.Item label="Remarks" name="remarks">
                <Input.TextArea
                  placeholder="Enter remarks"
                  disabled={isDisabled && isSuccess}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      ),
    },
  ];

  return (
    <>
      <div className="main-div">
        {console.log('newBBSdatatocheckforinvalid: ', newBBSMessage)}
        {(!newBBSMessage && newBBSData?.length > 0) ||
        (newBBSMessage === 'No results found for search.' &&
          Array.isArray(newBBSData) &&
          newBBSData.length === 0) ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              marginTop: '25px',
              padding: '20px',
              gap: '10px',
            }}
          >
            {console.log('selectedBbs!@#:')}

            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '10px',
                gap: '6px',
              }}
            >
              <div className="relative search_icon ">
                <img
                  src={search_icon}
                  alt="search"
                  className="absolute left-2"
                />
                <input
                  type="text"
                  placeholder="Search by project code"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="py-2 pl-8 border border-gray-300 rounded-lg w-48"
                />
              </div>
              <Button
                onClick={() =>
                  navigate('/request-approval', { state: { isFormOpen: true } })
                }
                className="custom-vis-btn bg-[#1C4E9D] rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif']"
                type="primary"
              >
                Add New Project
              </Button>
            </div>
            <DashboardCreateTable
              dataSource={dataSource11}
              columns={columns}
              //rowKey={(record) => record.key}
              //pagination={false}
              // style={{ width: '100%' }}
              //scroll={{ x: 'max-content' }}
              searchQuery={searchQuery}
            />

            <Modal
              open={isModalVisible}
              onOk={handleConfirm}
              onCancel={handleCancel}
              footer={[
                <div
                  className="flex justify-center gap-1 mt-3"
                  key="footer-buttons"
                >
                  <Button
                    className="custom-cancel-btn rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] text-[#344054] md:w-[170px] w-auto"
                    key="cancel"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  {selectedBbs?.isOptimised === false ? (
                    <Button
                      className="custom-vis-btn bg-[#1C4E9D] rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] text-[#FFFFFF] md:w-[190px] w-auto"
                      key="download"
                      type="primary"
                      onClick={() => handleCsvFileForAlgorithm()}
                      loading={bbsAlgorithmLoading}
                      disabled={
                        selectedBbs?.isOptimised === false &&
                        selectedBbs?.isActive == false
                      }
                    >
                      Optimise
                    </Button>
                  ) : (
                    <Button
                      className="custom-vis-btn bg-[#1C4E9D] rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] text-[#FFFFFF] md:w-[190px] w-auto"
                      key="download"
                      type="primary"
                      onClick={() => downloadMappingSheet(selectedBbs?.bbs)}
                    >
                      Download Mapping Sheet
                    </Button>
                  )}
                </div>,
              ]}
              style={{ zIndex: 1050 }}
              title={null}
              width={1100}
            >
              {/* <p className="mb-2 font-semibold">Input File(s):</p> */}
              <div className="flex">
                {inputFiles?.length > 0 ? (
                    <ul className="flex gap-2">
  {inputFiles.map((file, index) => {
    try {
      const parsedFile = typeof file === 'string' ? JSON.parse(file) : file;
      const blobName = parsedFile.uploadedUrl;
      const fullFilename =
        parsedFile.originalName ||
        parsedFile.filename ||
        'Unknown File';

      const isDownloading = downloadingIndex === index;
      const truncatedFilename =
        fullFilename.length > 12
          ? `${fullFilename.substring(0, 12)}...`
          : fullFilename;

      return (
        <li key={index}>
          <div
            onClick={() =>
              isDownloading
                ? null
                : downloadInputFiles(blobName, fullFilename, index)
            }
            className={`cursor-pointer w-[219px] flex gap-4 p-[10px] border-[1px] border-[#EAECF0] rounded h-[47px] items-center ${
              isDownloading ? 'opacity-50 pointer-events-none' : ''
            }`}
          >
            <img
              className="h-[20px] w-[20px]"
              src={excel_icon}
              alt="Excel Icon"
            />
            <p
              className="text-[#344054] text-[11px] font-medium truncate"
              title={fullFilename}
            >
              {isDownloading ? 'Downloading...' : truncatedFilename}
            </p>
            <img
              className="ml-5 mt-2 h-[18px] w-[18px]"
              src={button_icon}
              alt="Download Icon"
            />
          </div>
        </li>
      );
    } catch (error) {
      console.error('Error parsing file:', error);
      return null;
    }
  })}
</ul>
                ) : null}
                {selectedBbs?.isOptimised === false &&
                selectedBbs?.isActive === true ? (
                  <img
                    className="cursor-pointer ml-5 mt-2 h-[18px] w-[18px]"
                    src={delete_icon}
                    alt="Delete Icon"
                    onClick={() => {
                      const userConfirmed = window.confirm(
                        'Are you sure? Your files will be replaced.',
                      );
                      if (userConfirmed) {
                        handleDelete(selectedBbs?.bbs);
                      }
                    }}
                  />
                ) : null}
              </div>

              <div className="flex flex-col gap-4 mt-0 xl:mt-3 xl:flex xl:flex-row xl:gap-2">
                {['Consolidated Data', 'Raw Optimized Data', 'Final BBS Summary'].map(
                           (text) => {
                             const typeMap = {
                               'Consolidated Data': 'consolidated-data',
                               'Raw Optimized Data': 'raw-data',
                               'Final BBS Summary': 'final',
                             };
               
                             const currentType = typeMap[text];
                             const isLoading = downloading === currentType;
               
                             return (
                               <div
                                 key={text}
                                 onClick={() => {
                                   if (isLoading) return; // Prevent double click
               
                                   if (currentType === 'final') {
                                     downloadFinalBBSSummary(selectedBbs?.bbs);
                                   } else {
                                     handleBbsClick(
                                       selectedBbs?.bbs,
                                       selectedBbs?.projectCode,
                                       currentType,
                                     );
                                   }
                                 }}
                                 className={`cursor-pointer w-[219px] flex gap-4 p-[10px] border rounded h-[47px] items-center ${
                                   isLoading ? 'opacity-50 pointer-events-none' : ''
                                 }`}
                               >
                                 <img className="h-[20px] w-[20px]" src={excel_icon} />
                                 <p className="text-[#344054] text-[11px] font-medium">
                                   {isLoading ? 'Downloading...' : text}
                                 </p>
                                 <img
                                   className="ml-5 mt-2 h-[18px] w-[18px]"
                                   src={button_icon}
                                 />
                               </div>
                             );
                           },
                         )}
              </div>

              {console.log('datatoSend123: ', dataToSend)}
              {console.log('hellojusttocheck: ', selectedBbs)}
              <div className="flex justify-end mb-6 mt-7">
                <Button
                  onClick={() =>
                    handle_PdfDownload_cuttingPattern(
                      selectedBbs?.bbs,
                      selectedBbs?.projectCode,
                    )
                  }
                  loading={pdfDownloadLoading}
                  disabled={selectedBbs?.isOptimised === false}
                  className="custom-vis-btn text-[#344054] font-['SF-Pro-Text-Regular, sans-serif'] text-[14px]"
                >
                  <img src={pdf_image} alt="PDF" className="mr-2" />
                  Download cutting pattern
                </Button>
              </div>

              {console.log('results for file: ', inputFiles)}
              <div style={{ marginTop: '20px' }}>
                {selectedBbs?.isOptimised === false ? (
                  <div className="flex items-center justify-center">
                    <img className="" src={Photos_empty}></img>
                  </div>
                ) : (
                  <VisualizationTable
                    bbsAlgorithmResult={results}
                    optimizationDate={optimizationDate}
                  />
                )}
              </div>
            </Modal>
          </div>
        ) : newBBSMessage === 'No data available.' ? (
          <div className="flex flex-col items-center justify-center">
            <img src={NoProject} alt="No Project" />
            <Button
              onClick={() =>
                navigate('/request-approval', { state: { isFormOpen: true } })
              }
              className="custom-vis-btn bg-[#1C4E9D] rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif']"
              type="primary"
            >
              <Tooltip title="You are not assigned to any project. Click above to add new project.">
                Add New Project
              </Tooltip>
            </Button>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default DashboardCreate;

// {
//   title: (
//     <span
//       style={{
//         marginLeft: '7px',
//         color: '#667085',
//         fontFamily: "'SF Pro Text', sans-serif",
//         fontWeight: '500',
//         fontSize: '12px',
//         display: 'flex',
//         alignItems: 'center',
//       }}
//     >
//       Project Code and Name
//     </span>
//   ),
//   dataIndex: 'project_code', // The array in bbsList
//   key: 'project_code',
//   width: '150px',
//   ellipsis: true,
//   render: (text, record) => {
//     console.log('record quantity : ', record);

//     return (
//       <span
//         style={{
//           marginLeft: '7px',
//           color: '#0092DD',
//           fontFamily: "'SF Pro Text', sans-serif",
//           fontWeight: '500',
//           fontSize: '12px',
//         }}
//       >
//         <a
//           onClick={() =>
//             handleProjectClick(record.RequestApproval.project_code)
//           } // Pass the text (project_code) here
//           style={{ textDecoration: 'underline', color: '#0092DD' }} // Underline and color
//         >
//           {record.RequestApproval.project_code}/
//           {record.RequestApproval.project_name}{' '}
//         </a>
//       </span>
//       // <div className="text-[#667085] text-[12px] font-['SF-Pro-Text-Regular, sans-serif'] ml-[8px]">
//       //   {record.project_name}/{text}{' '}
//       //   {/* Combine project_code and project_name */}
//       // </div>
//     );
//   },
// },

//another for existing bbs:

// {
//   title: (
//     <span
//       style={{
//         marginLeft: '7px',
//         color: '#667085',
//         fontFamily: "'SF Pro Text', sans-serif",
//         fontWeight: '500',
//         fontSize: '12px',
//         display: 'flex',
//         alignItems: 'center',
//       }}
//     >
//       Existing BBS
//     </span>
//   ),
//   dataIndex: 'BBs',
//   key: 'BBs',
//   width: '168px',
//   ellipsis: true,
//   render: (BBs, record) => {
//     const projectCode = record?.RequestApproval?.project_code;
//     const bbsArray = record?.RequestApproval?.BBs || [];
//     const displayBbs = bbsArray.slice(0, 4); // Get the first 4 bbs_id
//     const remainingBbsArray = bbsArray.slice(4); // Remaining BBS
//     const remainingCount = remainingBbsArray.length; // Count the remaining bbs_id

//     const isRowVisible = rowVisibility[projectCode] || false; // Check if the row is expanded

//     return (
//       <span
//         style={{
//           marginLeft: '7px',
//           color: '#0092DD',
//           fontFamily: "'SF Pro Text', sans-serif",
//           fontWeight: '500',
//           fontSize: '12px',
//           display: 'flex',
//           flexWrap: 'wrap',
//           gap: '5px',
//         }}
//       >
//         {displayBbs.map((bbs, index) => (
//           <div key={index} style={{ display: 'flex', gap: '5px' }}>
//             {bbs?.is_active === true ? (
//               <a
//                 // key={index}
//                 style={{
//                   textDecoration: 'underline',
//                   color: '#0092DD',
//                   display: 'block',
//                 }}
//                 onClick={() =>
//                   handleBbsClick1(
//                     bbs.bbs_id,
//                     record.RequestApproval.project_code,
//                     bbs.is_optimised,
//                     bbs.is_active,
//                     bbs.optimization_date,
//                   )
//                 }
//               >
//                 {bbs?.bbs_id || 'N/A'}
//               </a>
//             ) : (
//               <span
//                 style={{
//                   textDecoration: 'underline',
//                   color: 'red',
//                   display: 'block',
//                   cursor: 'pointer',
//                 }}
//                 onClick={() =>
//                   handleBbsClick1(
//                     bbs.bbs_id,
//                     record.RequestApproval.project_code,
//                     bbs.is_optimised,
//                     bbs.is_active,
//                     bbs.optimization_date,
//                   )
//                 }
//               >
//                 {bbs?.bbs_id || 'N/A'}
//               </span>
//             )}
//             {bbs?.is_optimised === false ? (
//                <Tooltip
//                title={bbs?.is_active === false ? "ID can't be used, optimize new BBS" : ''}
//                placement="top"
//                mouseEnterDelay={0.3} // Optional: Delay before showing tooltip
//              >
//               <span
//                 style={{
//                   backgroundColor:
//                     bbs?.is_active === false ? '#FFE4E4' : '#FFF4E0', // Light red for Deactivated, Light yellow for Pending
//                   padding: '4px 5px',
//                   marginTop: '2px',
//                   color: bbs?.is_active === false ? '#D40000' : '#FFB800', // Dark red for Deactivated, Dark yellow for Pending
//                   fontSize: '7px',
//                   fontWeight: 'bold',
//                   marginLeft: '2px',
//                   width: bbs?.is_active === false ? '48px' : '38px', // 48px for Deactivated, 38px for Pending
//                   textAlign: 'center',
//                   borderRadius: '3px', // Optional: Add rounded corners
//                 }}
//               >
//                 {bbs?.is_active === false ? 'Deactivated' : 'Pending'}
//               </span>
//               </Tooltip>
//             ) : null}
//           </div>
//         ))}
//         {remainingCount > 0 && (
//           <a
//             onClick={() => toggleRemaining(projectCode)}
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               color: '#667085',
//               fontSize: '12px',
//               width: '30px',
//               cursor: 'pointer',
//               marginLeft: '128px',
//               marginTop: '-21px',
//             }}
//           >
//             <span
//               style={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 width: '30px',
//                 borderRadius: '50%',
//                 backgroundColor: '#FFFFFF',
//                 color: '#0092DD',
//                 fontSize: '10px',
//                 fontWeight: 'bold',
//                 marginRight: '4px',
//                 border: '1px solid #EAECF0',
//               }}
//             >
//               +{remainingCount}
//             </span>
//           </a>
//         )}
//         {isRowVisible &&
//           remainingBbsArray.map((bbs, index) => (
//             <div
//               key={`remaining-${projectCode}-${index}`}
//               style={{ display: 'flex', gap: '5px' }}
//             >
//               {bbs?.is_active === true ? (
//                 <a
//                   style={{
//                     textDecoration: 'underline',
//                     color: '#0092DD',
//                     display: 'block',
//                   }}
//                   onClick={() =>
//                     handleBbsClick1(
//                       bbs.bbs_id,
//                       record.RequestApproval.project_code,
//                       bbs.is_optimised,
//                       bbs.is_active,
//                       bbs.optimization_date,
//                     )
//                   }
//                 >
//                   {bbs?.bbs_id || 'N/A'}
//                 </a>
//               ) : (
//                 <span
//                   style={{
//                     textDecoration: 'underline',
//                     color: 'red',
//                     display: 'block',
//                     cursor: 'pointer',
//                   }}
//                   onClick={() =>
//                     handleBbsClick1(
//                       bbs.bbs_id,
//                       record.RequestApproval.project_code,
//                       bbs.is_optimised,
//                       bbs.is_active,
//                       bbs.optimization_date,
//                     )
//                   }
//                 >
//                   {bbs?.bbs_id || 'N/A'}
//                 </span>
//               )}
//               {bbs?.is_optimised === false ? (
//                 <span
//                   style={{
//                     backgroundColor: '#FFE4E4',
//                     padding: '4px 5px',
//                     marginTop: '2px',
//                     color: 'red',
//                     fontSize: '7px',
//                     fontWeight: 'bold',
//                     marginLeft: '2px',
//                     width: '38px',
//                   }}
//                 >
//                   Pending
//                 </span>
//               ) : null}
//             </div>
//           ))}
//       </span>
//     );
//   },
// },
